import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 25,
  },
  outsideEdge: {
    borderWidth: 3,
    borderColor: "#077A97",
    width: 115,
    height: 115,
    borderRadius: 70,
    alignSelf: "center",
    marginTop: 20,
  },
  contentBtn: {
    marginTop: "10%",
    flex: 1,
    paddingHorizontal: 25,
  },
  button: {
    fontFamily: "Poppins, sans-serif",
    padding: 10,
    width: 320,
    height: 38,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: "#077A97",
    marginVertical: 12,
    alignSelf: "center",
    color: "#fff",
  },
  textBtn: {
    textTransform: "uppercase",
    color: "#fff",
    textAlign: "center",
    fontSize: 18,
    fontWeight: "500",
  },
  innerEdge: {
    borderWidth: 10,
    borderColor: "#077A97",
    width: 100,
    height: 100,
    borderRadius: 50,
    alignSelf: "center",
    marginTop: 4,
  },
  imgMedal: {
    width: 48,
    height: 65.8,
    alignSelf: "center",
    marginTop: 6,
  },
  level: {
    fontSize: 25,
    fontWeight: "700",
    color: "#fff",
    alignSelf: "center",
    position: "absolute",
    top: 16,
  },
  descriptionLevel: {
    marginTop: 20,
    fontWeight: "500",
    textAlign: "center",
  },
  nextSteps: {
    textAlign: "center",
    marginTop: 20,
    fontWeight: "bold",
  },
  contentDescriptionNextSteps: {
    marginTop: 20,
  },
  premiumBenefits: {
    textAlign: "center",
    marginTop: 20,
    fontWeight: "bold",
  },
  contentDescriptionPremiumBenefits: {
    marginTop: 20,
  },
  contentTimeline: {
    marginTop: 20,
    flexDirection: "row",
    justifyContent: "center",
  },
  stepConcluded: {
    width: 24,
    height: 24,
    borderRadius: 20,
    backgroundColor: "#003535",
    alignItems: "center",
    justifyContent: "center",
  },
  stepNoConcluded: {
    width: 24,
    height: 24,
    borderRadius: 20,
    backgroundColor: "#077A97",
    alignItems: "center",
    justifyContent: "center",
  },
  stepLineConcluded: {
    borderWidth: 1,
    borderColor: "#003535",
    width: 100,
    height: 2,
    marginTop: 12,
  },
  stepLineNoConcluded: {
    borderWidth: 1,
    borderColor: "#077A97",
    width: 100,
    height: 2,
    marginTop: 12,
  },

  numberLevel: {
    fontSize: 14,
    fontWeight: "700",
    color: "#fff",
    alignSelf: "center",
  },
});

export default styles;
